module.exports = __webpack_public_path__ + "static/media/sky_2.149d474e.jpg";